/** KBL brand mark: gradient tile with a circuit-style "K". */
export const LogoMark = ({ className = 'h-9 w-9' }) => (
  <span
    className={`grid shrink-0 place-items-center rounded-[10px] bg-gradient-to-br from-indigo-600 to-violet-600 shadow-[0_6px_20px_-8px_rgba(99,102,241,0.9)] ${className}`}
    aria-hidden="true"
  >
    <svg viewBox="0 0 64 64" className="h-[62%] w-[62%]" fill="none" stroke="#fff" strokeWidth="6" strokeLinecap="round">
      <line x1="21" y1="12" x2="21" y2="52" />
      <line x1="21" y1="32" x2="45" y2="12" />
      <line x1="21" y1="32" x2="45" y2="52" />
      <circle cx="21" cy="32" r="5.5" fill="#fff" stroke="none" />
    </svg>
  </span>
);

const Logo = ({ className = '' }) => (
  <span className={`inline-flex items-center gap-2.5 ${className}`}>
    <LogoMark />
    <span className="text-[15px] font-bold leading-none tracking-tight text-fg">
      KBL <span className="font-semibold text-subtle">Web Solutions</span>
    </span>
  </span>
);

export default Logo;
